import p10 from "assets/images/promotion/10.png";
import p20 from "assets/images/promotion/20.png";
import p30 from "assets/images/promotion/30.png";
import p40 from "assets/images/promotion/40.png";
import p50 from "assets/images/promotion/50.png";
import buy1get1 from "assets/images/promotion/buy1get1.png";
import mua1tang1 from "assets/images/promotion/mua1tang1.png";
import pnew from "assets/images/promotion/new.png";
import promotion from "assets/images/promotion/promotion.png";
import uudai from "assets/images/promotion/uudai.png";
import voucher from "assets/images/promotion/voucher.png";

export const promotionTypes = {
  en: {
    10: p10,
    20: p20,
    30: p30,
    40: p40,
    50: p50,
    buy1get1: buy1get1,
    new: pnew,
    promotion: promotion,
    voucher: voucher,
  },
  vi: {
    10: p10,
    20: p20,
    30: p30,
    40: p40,
    50: p50,
    buy1get1: mua1tang1,
    new: pnew,
    promotion: uudai,
    voucher: voucher,
  },
};
